<template>
  <el-dialog title="查看电子票" :visible.sync="show" width="80%">

  <div class="t1">

    <div class="body">

      <div class="t2">

        <div class="ele_info">
          <div class="inside">
            <table>
              <tr class="ttr">
                <td colspan="4" class="tt">
                  <div class="tit2">
                  
			<span  >{{strs.ttt}}</span>
                  </div>
                </td>

              </tr>

              <tr class="ttr">
                <td class="tt">
                  <div class="tit2">
                    <span> 便名 </span>
                  </div>
                </td>
                <td class="cc">
                  <div class="con">

                 
			<span  >{{strs.ttt}}</span>

                  </div>
                </td>
                <td class="tt">
                  <div class="tit2">
                    <span>予約番号 </span>
                  </div>
                </td>
                <td class="cc">
                  <div class="con">
                    <span>{{ itm.sn }} </span>
                  </div>
                </td>
              </tr>
              <tr class="ttr">
                <td class="tt">
                  <div class="tit2">
                    <span>記号番号</span>
                  </div>
                </td>
                <td class="cc">
                  <div class="con">
                    <span>{{ itm.ticket_sn }} </span>
                  </div>
                </td>
                <td class="tt">
                  <div class="tit2">
                    <span>出発日 </span>
                  </div>
                </td>
                <td class="cc">
                  <div class="con">
                    <span>{{ itm.date }} </span>
                  </div>
                </td>
              </tr>
              <tr class="ttr">
                <td class="tt">
                  <div class="tit2">
                    <span> 出発場所 </span>
                  </div>
                </td>
                <td class="cc">

                  <div class="con">

                 	<span  class="con" >{{strs.start}}</span>

                  </div>



                </td>
                <td class="tt">
                  <div class="tit2">
                    <span> 降車場所 </span>
                  </div>
                </td>
                <td class="cc">
                  <div class="con">



                    <div class="con">


			 		<span   class="con" >{{strs.end}}</span>

                      </div>

                  </div>
                </td>
              </tr>
              <tr class="ttr">
                <td class="tt">
                  <div class="tit2">
                    <span>乗客情報</span>
                  </div>
                </td>
                <td class="cc">
                  <div class="con">
                    <span class="text2" v-for="(vo, x) in itm.contacts" :key="x">
                      {{ vo .jp_name}}
                      {{ vo .strs.sex}}
                      {{ vo .age}} {{ $lang(42361)}}
                    </span>

                  </div>
                </td>
                <td class="tt">
                  <div class="tit2">
                    <span> 連絡番号 </span>
                  </div>
                </td>
                <td class="cc">
                  <div class="con">
                    <span> {{itm.ticket_tel}} </span>
                  </div>
                </td>
              </tr>
              <tr class="ttr">
                <td class="tt">
                  <div class="tit2">
                    <span>お支払い</span>
                  </div>
                </td>
                <td class="cc">
                  <div class="con">
                    <span>{{ itm.ticket_pay }}</span>
                  </div>
                </td>
                <td class="tt">
                  <div class="tit2">
                    <span> </span>
                  </div>
                </td>
                <td class="cc">
                  <div class="con">
                    <span></span>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 票据文件区：有 file 或 ticket_link 才渲染 -->
        <div class="remarks" v-if="itm.file || itm.ticket_link">
          <!-- 分支 A：pdf 或有外链 → 直接按顺序展示票据图片 -->
          <div v-if="isPdf(itm.file) || itm.ticket_link">
            <div v-if="jpgs.length" class="ticket-imgs">
              <img v-for="(u, x) in jpgs" :key="x" class="imgzz" :src="u" alt="">
            </div>
            <!-- 无图片源但为 pdf → 内嵌 pdf -->
            <iframe v-else-if="isPdf(itm.file)" class="ifrzz" :src="itm.strs.file" frameborder="0"></iframe>
          </div>
          <!-- 分支 B：普通图片 → 直接内嵌显示 -->
          <img v-else class="imgzz" :src="itm.strs.file" alt="">
        </div>
        <div class="remarks">
          <div class="tit">
            <span>備考</span>
          </div>

          <div class="text">
            <span> {{ itm.ticket_note }} </span>
          </div>
        </div>

        <div class="btn">
          <div class="btn2">
            <el-button type="primary"> <i class="el-icon-printer"></i><span>打印电子发票</span> </el-button>
          </div>
          <div class="btn2">
            <el-button type="primary" @click="send_mail"><i class="el-icon-message"></i> <span>发送邮件</span> </el-button>
          </div>

        </div>

      </div>
    </div>
  </div>

  </el-dialog>
</template>

<script>
export default {
    name:"electronic_ticket",
    data(){
        return{
            strs : {},
            a:'ele_ticket',
            itm : {},
            show: false,
            // 来自接口的 jpgs 数组
            jpgs: [],
        }
    },

    components:{

    },
    mounted(e) {


  },
    methods: {

    // 判断 file 是否为 pdf（注意：indexOf 找不到返回 -1 是真值，必须 !== -1）
    isPdf(file) {
      return !!(file && typeof file === 'string' && file.indexOf('pdf') !== -1);
    },
    f5(sn) {
      this.get("/order/electronic_ticket", { sn: sn }).then((e) => {
        this.strs = e.strs
        this.itm = e.order
        this.jpgs = e.jpgs || []
           this.show = true
        if (this.itm.train) {
          this.itm.train.strs = e.strs
        }
      });
    },
    send_mail() {
      this.get("/order/send_mail", { sn: this.itm.sn }).then((e) => {

        this.$message(
        this.$lang(42712)
        );
      });
    },

  }

}
</script>

<style  scoped>
.imgzz {
  width: 50%;
  margin: auto;
}
.ifrzz {
  width: 80%;
  min-height: 40vw;
  margin: auto;
}
.ticket-imgs {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.ticket-imgs .imgzz {
  width: 70%;
  margin: 0;
}
.t1{
    display: flex;
    flex-direction: column;
}
.body{
    display: flex;
}
.t2 .ele_info{
    margin-top: 1%;
    margin-left: 1%;
    width:58vw;

    box-sizing: border-box;
    background: rgb(255, 255, 255);
    border: 1px solid rgba(108, 117, 125, 0.1);
    border-radius: 10px;
    padding: 2%;
}
.t2 .ele_info .inside{
    width: 100%;
    height: 100%;
}
.t2 .ele_info .inside table{
    border-top: 1px solid rgb(229, 230, 235);
}
.t2 .ele_info .inside .ttr td{
    border-bottom: 1px solid rgb(229, 230, 235);
}
.t2 .ele_info .inside .tt{
    width: 10vw;
    height: 6vh;
    background: rgb(247, 248, 250);

}
.t2 .ele_info .inside .cc{
    width: 20vw;

}
.t2 .ele_info .inside .tit2{
    width: 100%;

}
.t2 .ele_info .inside .tit2 span{
    margin-left: 15%;
    color: rgb(66, 84, 134);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0%;
    text-align: center;
}
.t2 .ele_info .inside .con {
    display: flex;
    flex-direction: column;
}
.t2 .ele_info .inside .con span{
    margin-left: 5%;
    color: rgb(108, 117, 125);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0%;

}
.t2 .remarks {
    margin-top: 1%;
    margin-left: 1%;

    width:58vw;
    min-height: 21.5vh;

    box-sizing: border-box;
    background: rgb(255, 255, 255);
    border: 1px solid rgba(108, 117, 125, 0.1);
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    padding: 20px 0px;
}
.t2 .remarks .tit {
    margin-top: 2%;
    margin-left: 2%;

}
.t2 .remarks .tit span{
    color: rgb(66, 84, 134);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 600;
    letter-spacing:0;
      padding: 20px;
}
.t2 .remarks .text {
    margin: 0 auto;
    margin-top: 2%;
    width:96%;
    height: 104px;

    background: rgb(249, 250, 254);
    border-radius: 2px;

    display: flex;
}
.t2 .remarks .text span{
    margin-top: 3%;
    margin-left: 3%;
    color: rgb(51, 102, 162);
    font-family: Noto Sans SC;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0%;

}
.t2 .btn {
    margin-top: 3%;
    margin-left: 1%;
    width: 100%;
    display: flex;
    justify-content:flex-end;
}
.t2 .btn .btn2{
    margin-left: 2%;

}
.t2 .btn .btn2 button{
    background: rgb(4, 100, 221);
    border-radius: 4px;

    display: flex;
}
.t2 .btn .btn2 button i{
    margin-right: 10%;
}
.t2 .btn .btn2 button span{
    margin: 0 auto;
    color: rgb(255, 255, 255);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0%;
    text-align: right;

}
</style>



// WEBPACK FOOTER //
// src/components/ticket_tc.vue